import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TextHelperService {
  /**
   * Substituindo as interpolações do texto HTML com as variáveis de um objeto
   * @param origText       texto que contém os placeholders
   * @param obj            objeto com as propriedades
   * @param objName        nível principal da variável/placeholder
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public trustHtml(origText: string, obj: any, objName?: string): string {
    const listaProp = Object.keys(obj);
    if (objName) {
      listaProp.forEach((prop: string) => {
        origText = origText.replace(
          new RegExp(`{{\\s*${objName}\\.\\s*${prop}\\s*}}`, 'g'),
          obj[prop]
        );
      });
    } else {
      listaProp.forEach((prop: string) => {
        origText = origText.replace(
          new RegExp(`{{\\s*${prop}\\s*}}`, 'g'),
          obj[prop]
        );
      });
    }

    return origText;
  }
}
